import { Dialog as MuiDialog, DialogProps as MUIDialogProps } from '@material-ui/core';
import { useEffect, PropsWithChildren, useRef } from 'react';
import { atom, selector, RecoilState, RecoilValue, useSetRecoilState } from 'recoil';
import { Colors } from 'styles';

export type DialogProps = PropsWithChildren<{
  variant?: 'dark' | 'light';
  open?: boolean;
}> &
  MUIDialogProps;

export const dialogOpenCount: RecoilState<number> = atom<number>({
  key: 'dialogOpenCount',
  default: 0,
});

export const isDialogOpenSelector: RecoilValue<boolean> = selector({
  key: 'isDialogOpen',
  get: ({ get }) => {
    return get(dialogOpenCount) > 0;
  },
});

const Dialog: React.FC<DialogProps> = ({ variant = 'dark', ...rest }): React.ReactElement => {
  const setDialogOpenCount = useSetRecoilState(dialogOpenCount);
  const wasOpen = useRef<boolean>(false);

  useEffect(() => {
    let decremented = false;

    if (rest.open) {
      setDialogOpenCount((count) => count + 1);
      wasOpen.current = true;
    } else {
      setDialogOpenCount((count) => Math.max(0, count - 1));
      wasOpen.current = false;
      decremented = true;
    }

    return () => {
      if (wasOpen.current && !decremented) {
        setDialogOpenCount((count) => Math.max(0, count - 1));
        wasOpen.current = false;
      }
    };
  }, [rest.open, setDialogOpenCount]);

  return (
    <MuiDialog
      {...rest}
      css={`
        .MuiDialog-paper {
          width: 450px;
          padding: 3rem;
          background-color: ${variant === 'light' ? Colors.gray10 : Colors.gray2};
          color: ${variant === 'light' ? Colors.gray1 : Colors.gray10};
        }
        .MuiDialogContent-root {
          padding: 0 0 3rem 0;
        }
      `}
    />
  );
};
export default Dialog;
